import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchGrammarTopicById,
  fetchGrammarSubTopicById,
  deleteGrammarSubTopic,
} from "./adminGrammarService";
import GrammarSubTopicForm from "./GrammarSubTopicForm";
import "../../blog/tongueTwister.css";

const AdminGrammarSubTopicPage = () => {
  const { topicId } = useParams();
  const navigate = useNavigate();
  const [topic, setTopic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingSubTopic, setEditingSubTopic] = useState(null);

  useEffect(() => { loadTopic(); }, [topicId]);

  const loadTopic = async () => {
    console.log("[GrammarSubTopicPage] Loading topic id:", topicId);
    setLoading(true);
    const res = await fetchGrammarTopicById(topicId);
    if (res.status === 200 && res.data) {
      console.log("[GrammarSubTopicPage] Topic loaded:", res.data.title, "subTopics:", res.data.subTopics?.length || 0);
      setTopic(res.data);
    } else {
      console.error("[GrammarSubTopicPage] Load topic failed:", res.status, res.message);
      alert(res.message || "Failed to load topic");
    }
    setLoading(false);
  };

  const handleEditSubTopic = async (subTopicId) => {
    console.log("[GrammarSubTopicPage] Fetching sub-topic for edit, id:", subTopicId);
    const res = await fetchGrammarSubTopicById(subTopicId);
    if (res.status === 200 && res.data) {
      console.log("[GrammarSubTopicPage] Sub-topic loaded for edit:", res.data.title);
      setEditingSubTopic(res.data);
      setShowForm(true);
    } else {
      console.error("[GrammarSubTopicPage] Fetch sub-topic failed:", res.status, res.message);
      alert(res.message || "Failed to load sub-topic");
    }
  };

  const handleDeleteSubTopic = async (id) => {
    if (!window.confirm("Delete this sub-topic?")) return;
    console.log("[GrammarSubTopicPage] Deleting sub-topic id:", id);
    const res = await deleteGrammarSubTopic(id);
    if (res.status === 200 || res.status === 204) {
      console.log("[GrammarSubTopicPage] Delete successful, reloading topic");
      loadTopic();
    } else {
      console.error("[GrammarSubTopicPage] Delete failed:", res.status, res.message);
      alert(res.message);
    }
  };

  const onSaved = () => {
    console.log("[GrammarSubTopicPage] Save successful, closing form and reloading");
    setShowForm(false);
    setEditingSubTopic(null);
    loadTopic();
  };

  if (loading) return <div className="admin-container"><p>Loading...</p></div>;
  if (!topic) return <div className="admin-container"><p>Topic not found</p></div>;

  return (
    <div className="admin-container">
      <button onClick={() => navigate("/admin/content/grammar")} style={{ marginBottom: 16, background: "none", border: "none", color: "#019095", cursor: "pointer", fontWeight: 600 }}>
        ← Back to Topics
      </button>

      <div className="admin-header">
        <h2>{topic.icon} {topic.title}</h2>
        <button onClick={() => { setEditingSubTopic(null); setShowForm(true); }}>+ New Sub Topic</button>
      </div>
      <p style={{ color: "#666", marginBottom: 20 }}>{topic.description}</p>

      {showForm && (
        <GrammarSubTopicForm
          subTopic={editingSubTopic}
          grammarTopicId={Number(topicId)}
          onSaved={onSaved}
          onCancel={() => { setShowForm(false); setEditingSubTopic(null); }}
        />
      )}

      <table className="announcement-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Sort Order</th>
            <th>Sections</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {(!topic.subTopics || topic.subTopics.length === 0) ? (
            <tr><td colSpan="5">No sub-topics yet</td></tr>
          ) : (
            topic.subTopics.map((st) => (
              <tr key={st.id}>
                <td style={{ fontWeight: 600 }}>{st.title}</td>
                <td style={{ textAlign: "center" }}>{st.sortOrder ?? "—"}</td>
                <td style={{ textAlign: "center" }}>{st.sectionCount || 0}</td>
                <td>{st.createdAt ? new Date(st.createdAt).toLocaleDateString() : "—"}</td>
                <td>
                  <button onClick={() => handleEditSubTopic(st.id)}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDeleteSubTopic(st.id)}>Delete</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminGrammarSubTopicPage;
